@if (customerConsents) {
  <div class="container-fluid list consents">
    @if (showGridHeaders()) {
      <div class="row colhdrs">
        <div class="colw colw-20 column-heading no-text-selection">
          <span i18n="Customer mobile phone number heading">Mobile Number</span>
        </div>
        <div class="colw colw-20 column-heading no-text-selection">
          <span i18n="Customer consent status heading">Consent Status</span>
        </div>
        <div class="colw colw-20 column-heading no-text-selection">
          <span i18n="Customer consent actions">Actions</span>
        </div>
      </div>
    }
    @if (hasConsents()) {
      <div>
        @for (consent of customerConsents; track consent) {
          <div class="list-row">
            @if (invalidConsentChangeErr) {
              <div class="error consent-error">
                <strong>{{ invalidConsentChangeErr }}</strong>
              </div>
            }
            <div class="row customer">
              <div class="colw colw-20">
                {{consent.channel_addr | phoneNumber}}
              </div>
              @if (isMatchingConsent(consent, consentBeingEdited)) {
                <div class="colw colw-20">
                  <rn-select
                    [name]="consentBeingEdited.consent_type"
                    [options]="getConsentTypes(consent)"
                    [selectedOption]="consentBeingEdited?.consent_type"
                    (selectChanged)="consentBeingEdited.consent_type = getSelectedValue($event)"
                  ></rn-select>
                </div>
              }
              @if (!isMatchingConsent(consent, consentBeingEdited)) {
                <div class="colw colw-20 consentType">
                  {{consent.consent_type}}
                </div>
              }
              @if (isMatchingConsent(consent, consentBeingEdited)) {
                <div class="colw colw-20">
                  <button id="save-btn" class="btn btn-primary consent" (click)="onConsentChange(consent.consent_type)">
                    <span id="save-button">Save</span></button>
                    <button id="cancel-btn" class="btn btn-remove consent" (click)="onCancelEditConsent()">
                      <span id="cancel-button">Cancel</span>
                    </button>
                  </div>
                }
                @if (!isMatchingConsent(consent, consentBeingEdited)) {
                  <div class="colw colw-20">
                    @if (canEditConsent) {
                      <div id="edit-consent-btn" class="btn btn-sm edit action-icon">
                        <i class="fa fa-pencil fa-lg action-button pointer" aria-hidden="true"
                          (click)="onStartEditConsent(consent)"
                          i18n="Button for editing mobile number"
                          matTooltip="Edit"
                          matTooltipPosition="above"
                          matTooltipClass="actions-tooltip-style"
                        ></i>
                      </div>
                    }
                    @if (canDeleteConsent) {
                      <div id="delete-consent-btn" class="btn btn-sm delete action-icon">
                        <i class="fa fa-trash fa-lg action-button pointer" aria-hidden="true"
                          (click)="onConfirmChannelDelete(consent.channel_addr)"
                          i18n="Button for deleting modile number"
                          matTooltip="Delete"
                          matTooltipPosition="above"
                          matTooltipClass="actions-tooltip-style"
                        ></i>
                      </div>
                    }
                    @if (canAddConsentGrid(consent)) {
                      <div id="add-consent-btn" class="btn btn-sm edit action-icon"
                        >
                        <i class="fa fa-plus fa-lg action-button pointer relay-icon" aria-hidden="true"
                          (click)="onStartAddPhoneNumber()"
                          i18n="Button for adding customer details"
                          matTooltip="Add New Mobile Number"
                          matTooltipPosition="above"
                          matTooltipClass="actions-tooltip-style"
                        ></i>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (showNoConsentMessage()) {
        <div class="row customer">
          <div class="row">
            <span>You haven't added any mobile numbers as of yet.</span>
          </div>
          @if (canAddConsent) {
            <div class="row">
              <button class="btn btn-primary" (click)="onStartAddPhoneNumber()">
                <span>Add new mobile number</span>
              </button>
            </div>
          }
        </div>
      }
      @if (channelBeingAdded) {
        <div class="row consent">
          @if (invalidAddPhoneErr) {
            <div class="error consent-error">
              <strong>{{ invalidAddPhoneErr }}</strong>
            </div>
          }
          <div class="colw colw-20">
            <input class= "mobile-number-input" id="client-trigger-id" [(ngModel)]="channelBeingAdded.channel_addr" (change)="forceNumeric(channelBeingAdded.channel_addr)" placeholder="Mobile Number"/>
          </div>
          <div class="colw colw-20">
            <rn-select
              id="new-consent-type-select"
              [name]="channelBeingAdded.consent_type"
              [selectedOption]="channelBeingAdded?.consent_type"
              [options]="getConsentTypes(channelBeingAdded.consent_type)"
              (selectChanged)="channelBeingAdded.consent_type = getSelectedValue($event)"
            ></rn-select>
          </div>
          <div class="colw colw-20">
            <button id="save-new-btn" class="btn btn-primary consent" (click)="onAddChannel()">
              <span id="save-new-button">Save</span>
            </button>
            <button id="cancel-new-btn" class="btn btn-remove consent" (click)="onCancelAddPhone()">
              <span id="cancel-new-button">Cancel</span>
            </button>
          </div>
        </div>
      }
    </div>
  }

  <message-dialog #confirmChannelDeleteDialog (affirm)="onRemoveChannel()" [showCancel]="true">
  </message-dialog>
